import { useEffect, useState } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;
const STORAGE_KEY = "revanche_session_id";

/**
 * Crée (ou récupère) une session anonyme au chargement.
 * Enregistre la source du visiteur (utm_source, sinon referrer).
 */
export function useSession() {
    const [session, setSession] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let active = true;
        const init = async () => {
            const existing = localStorage.getItem(STORAGE_KEY);
            if (existing) {
                try {
                    const { data } = await axios.get(`${API}/session/${existing}`);
                    if (active) setSession(data);
                    if (active) setLoading(false);
                    return;
                } catch (e) {
                    localStorage.removeItem(STORAGE_KEY);
                }
            }
            try {
                const params = new URLSearchParams(window.location.search);
                const payload = {
                    utm_source: params.get("utm_source") || null,
                    referrer: document.referrer || null,
                    landing_path: window.location.pathname + window.location.search,
                    user_agent: navigator.userAgent,
                    ref: params.get("ref") || null,
                };
                const { data } = await axios.post(`${API}/session`, payload);
                localStorage.setItem(STORAGE_KEY, data.session_id);
                if (active) setSession(data);
            } catch (e) {
                console.error("session init failed", e);
            } finally {
                if (active) setLoading(false);
            }
        };
        init();
        return () => {
            active = false;
        };
    }, []);

    return { session, loading };
}
